import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Community } from "model/Community/Community";

export interface ICommunitySlice {
  intialLoadComplete: boolean;
  data: Community[];
}

const initialState: ICommunitySlice = {
  intialLoadComplete: false,
  data: [],
};

export const communitySlice = createSlice({
  name: "community",
  initialState,
  reducers: {
    updateCommunities: (
      state,
      action: PayloadAction<{
        communities: Community[];
      }>
    ) => {
      state.data = action.payload.communities;

      if (!state.intialLoadComplete) {
        state.intialLoadComplete = true;
      }
    },
  },
});

export const { updateCommunities } = communitySlice.actions;
export const communityReducer = communitySlice.reducer;
